// extracted by mini-css-extract-plugin
export var indeterminate = "_56-5";
export var md = "_56-4";
export var semantic = "_56-6";
export var sm = "_56-3";
export var text = "_56-7";
export var toggleInput = "_56-0";
export var toggleSwitch = "_56-1";
export var xs = "_56-2";